
import React from "react";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";

const products = [
  {
    id: 2001,
    name: "1000ml Matte Black Stainless Steel Vacuum Insulated Water Bottle With Carrying Strap Durable And Stylish",
    price: 1890,
    image: "/image/kids/Matte Black Stainless Steel Vacuum Insulated Water Bottle With Carrying Strap.png",
  },
  {
    id: 2002,
    name: "Double-Sided Prank Water Gun Toy – Funny Summer Squirt Pistol Water Toy for Kids, Outdoor Pool & Beach Parties",
    price: 396 ,
    image: "/image/kids/Double-Sided Prank Water Gun Toy.jpg",
  },
  {
    id: 2003,
    name: "Premium 6-in-1 Electric Baby Nail Trimmer Set – Safe Infant Nail Filer, Clipper Alternative Kit with Storage Case - Random Color",
    price: 800,
    image: "/image/kids/Premium 6-in-1 Electric Baby Nail Trimmer Set.jpg",
  },
  {
    id: 2004,
    name: "Premium Refrigerator Children's Lock – Self-Adhesive Baby Safety Freezer Door Lock with One-Hand Operation",
    price: 315,
    image: "/image/kids/Premium Refrigerator Children's Lock.png",
  },
  {
    id: 2005,
    name: "Food Pacifier + Feeder Spoon / Fresh Fruit Food Baby , Feeding Safe Fruit Feeder - Random Color",
    price: 305,
    image: "/image/kids/Food Pacifier + Feeder Spoon.jpg",
  },
  {
    id: 2006,
    name: "360° U-Shaped Baby Toothbrush | Soft Silicone Kids Oral Care & Teether Brush (Random Color)",
    price: 110,
    image: "/image/kids/U-Shaped Baby Toothbrush -Soft Silicone Kids Oral Care & Teether Brush.png",
  },
  {
    id: 2007,
    name: "Baby Spoon Feeder Silicone Bottle Feeding (Random Color)",
    price: 225,
    image: "/image/kids/Baby Spoon Feeder Silicone Bottle Feeding.jpg",
  },
  {
    id: 1008,
    name: "Next Nova Imported 10 Portable Air Cooler Fan – 3-in-1 Mini AC Desktop Humidifier 7-Color LED",
    price: 2200,
    image: "/image/shop/Portable Air Cooler Fan.jpg",
  },
  {
    id: 2009,
    name: "Baby Carrier, Ergonomic Baby Strap one Shoulder Labor-Saving Polyester Baby Half Wrapped Sling (Random Color)",
    price: 550,
    image: "/image/kids/Baby Carrier, Ergonomic Baby Strap one Shoulder Labor-Saving Polyester Baby Half Wrapped Sling (Random Color).jpg",
  },
  {
    id: 2010,
    name: "TECNO Plus GA-88 Portable AC/DC Table Fan – 12V Car & 220V Home Fan | Adjustable Mini Desk Fan for Office, Travel & Load Shedding | 8x6 Inches",
    price: 1071,
    image: "/image/kids/TECNO Plus GA-88 Portable AC-DC Table Fan.png",
  },
  {
    id: 2011,
    name: "Heavy Duty 9 In 1 MulPremium Large Size Portable Handheld Fan – High-Speed USB Rechargeable Cooling Fan with Cute Fruit Design (Random Color & Box)",
    price: 585,
    image: "/image/kids/Premium Large Size Portable Handheld Fan – High-Speed USB Rechargeable Cooling Fan.jpeg",
  },
  {
    id: 2012,
    name: "Premium Large Size Portable Handheld Fan – High-Speed USB Rechargeable Cooling Fan.jpeg",
    price: 850,
    image: "/image/kids/Portable Bladeless Neck Cooler – Hands-Free.jpeg",
  },
  {
    id: 1013,
    name: "Balebaily Long Wallet for Men & Women with Zipper Pocket - Black",
    price: 801,
    image: "/image/shop/Balebaily Long Wallet.png",
  },
  {
    id: 1014,
    name: "750ml Sports Water Bottle – Leakproof BPA-Free Gym & Fitness Drinking Bottle | Random Color",
    price: 975,
    image: "/image/shop/750ml Sports Water Bottle.jpeg",
  },
  {
    id: 1015,
    name: "Leakproof Replacement Lid Compatible with 40oz Tumblers | Random Color",
    price: 510,
    image: "/image/shop/Leakproof Replacement Lid Compatible.jpeg",
  },
  {
    id: 1016,
    name: "Peva Material Universal Electric Fan Dust Cover Prevent Aging Of Fan Blades Circular Electric Fan Sleeve Electric Fan Cover(random design )",
    price: 370,
    image: "/image/shop/Peva Material Universal Electric Fan Dust Cover.jpg",
  },
  {
    id: 1017,
    name: "Premium SZM 750ml Stainless Steel Water Bottle Leakproof | Random Color",
    price: 1751,
    image: "/image/shop/Premium SZM 750ml Stainless Steel Water Bottle Leakproof.jpeg",
  },
  {
    id: 1018,
    name: "ACNIX Anti Acne Face Wash Deep Cleansing Formula With Benzoyl Peroxide And Aloe Vera 120 ml",
    price: 910,
    image: "/image/shop/ACNIX Anti Acne Face Wash Deep Cleansing.png",
  },
  {
    id: 1019,
    name: "Acrylic Mirror Ayat ul Kursi Car Hanging Decor – Black & Golden Islamic Rear View Mirror Pendant | Size: 12 × 8",
    price: 480,
    image: "/image/shop/Acrylic Mirror Ayat ul Kursi Car Hanging Decor.jpeg",
  },
  {
    id: 1020,
    name: "Regal Steel Body Hot And Cold Water Cooler 10 Liter With Temperature Control And Elegant Floral Design",
    price: 8470,
    image: "/image/shop/Regal Steel Body Hot And Cold Water Cooler.png",
  },
  {
    id: 1021,
    name: "Set of 3 Premium Wall Art Photo Tiles – Modern Home Decor Sets",
    price: 335,
    image: "/image/shop/RAF Professional Electric Coffee & Spice Grinder – 300W High-Power Stainless Steel Masala Grinder.png ",
  },
  {
    id: 1022,
     name: "2-In-1 Universal Cup Phone Drinks Holder Bicycle Adjustable Cell Phone Holder Water Bottle Multifunctional Universal Cup Holder",
    price: 855,
    image: "/image/shop/2-In-1 Universal Cup Phone Drinks Holder.jpeg",
  },
  {
    id: 1023,
    name: "Malina Embroidered Luxury Lawn Unstitched 3Pc Suit – Ice Blue Floral Digital Print with Chiffon Dupatta",
    price: 3231,
    image: "/image/shop/Malina Embroidered Luxury Lawn Unstitched 3Pc Suit.jpg",
  },
  {
    id: 1024,
   name: "RAF Professional Electric Coffee & Spice Grinder – 300W High-Power Stainless Steel Masala Grinder",
    price: 1180,
   image: "/image/shop/RAF Professional Electric Coffee & Spice Grinder – 300W High-Power Stainless Steel Masala Grinder.png",
  },
  {
    id: 1025,
    name: "Sabawoon Super Fast Data Cable 1000mm USB-A to Type-C Charging Cable",
    price: 315,
    image: "/image/shop/Sabawoon Super Fast Data Cable 1000mm.png",
  },
  {
    id: 1026,
    name: "USB Mini LED Light – Portable High-Brightness Plug & Play Lamp for Laptops, Power Banks & Chargers",
    price: 150,
    image: "/image/shop/USB Mini LED Light.jpeg",
  },
  {
    id: 1027,
    name: "Vintage T9 Professional Trimmer – Close-Cutting T-Blade Hair Clipper for Men - Metal Body",
    price: 750,
    image: "/image/shop/Vintage T9 Professional Trimmer.jpg",
  },
  {
    id: 1028,
    name: "Bolt/ex 12V Router Power Bank – High-Performance UPS for Non-Stop Internet (3-4 Hours Backup) - 20000Mah Battery",
    price: 1560,
    image: "/image/shop/Boltex12VRouterPowerBank.png",
  },
  {
    id: 1029,
    name: "Premium Skull Headlamp for Honda CD70 & CG125 – Aggressive Red Skull DRL with Dual LED Projectors",
    price: 2205,
    image: "/image/shop/Premium Skull Headlamp for Honda CD70 & CG125.jpeg",
  },
  {
    id: 1030,
    name: "Fontec Glow Wireless Earbuds – Bluetooth 5.3 Gaming Earphones with ENC Noise Cancellation & Transparent Charging Case",
    price: 2583,
    image: "/image/shop/Fontec Glow Wireless Earbuds – Bluetooth 5.3 Gaming Earphones with ENC Noise Cancellation.png",
  },
  {
    id: 1031,
    name: "2-in-1 Mini Hair Straightener & Curler – Portable Thermostatic Ceramic Flat Iron for Dry & Wet Hair Styling - Random Color",
    price: 425,
    image: "/image/shop/Mini Hair Straightener & Curler.jpeg",
  },
  {
    id: 1032,
    name: "Digital Blood Pressure Monitor – Accurate BP & Pulse Checker DBP-1333",
    price: 5121,
    image: "/image/shop/Digital Blood Pressure Monitor – Accurate BP & Pulse Checker DBP-1333.jpg",
  },
];

const Kids = () => {


  const navigate = useNavigate();
  return (
    <>
          <TopBar />
          <Navbar />
     
    <div className="min-h-screen bg-slate-100">
     


        {/* Hero Section */}
        <div className="bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white py-14">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl font-bold mb-4">
              Kids Collection
            </h1>
            <p className="text-xl opacity-90">
              Toys, School Items, Clothing & Fun Products for Kids
            </p>
          </div>
        </div>



      {/* Products Section */}
      <div className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold mb-8 text-slate-800">
          Featured Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden group"
            >
              {/* Product Image */}
              <div className="h-64 bg-gray-50 p-4 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full object-contain group-hover:scale-105 transition duration-300"
                />
              </div>

              {/* Product Details */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-slate-800 line-clamp-2 min-h-[56px]">
                  {product.name}
                </h3>

                <div className="flex items-center justify-between mt-4">
                  <span className="text-2xl font-bold text-orange-600">
                    Rs {product.price.toLocaleString()}
                  </span>
                </div>

                {/* <button className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300">
                  Add to Cart
                </button> */}
                <button
                        onClick={() => navigate(`/product/${product.id}`)}
                        className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300"
                        >
                        View Details
                        </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
     </>
  );
};

export default Kids;






